@if (column.isLink && !column.click) {
    @if (column.customRoute) {
        <app-link [route]="[column.customRoute.path, defaultViewMode, row[column.customRoute.field]]">
            <div [ngClass]="{ 'font-medium': column.isBold }">{{ row[column.field] }}</div>
        </app-link>
    } @else {
        <app-link [route]="[parentRoute, defaultViewMode, row?.id]">
            <div [ngClass]="{ 'font-medium': column.isBold }">{{ row[column.field] }}</div>
        </app-link>
    }
} @else if (column.isLink && column.click) {
    <app-link (click)="column.click(row)">
        <div [ngClass]="{ 'font-medium': column.isBold }">{{ row[column.field] }}</div>
    </app-link>
} @else if (column.click && !column.icon) {
    <app-link (click)="column.click(row)">
        <div [ngClass]="{ fk: column.isBold }">{{ row[column.field] }}</div>
    </app-link>
} @else if (column.type === 'codelist') {
    <ng-container *ngIf="row[column.field] | codelist: column.codelistName | async as codelist">
        @if (column.codelistTooltip) {
            @if (column.codelistPill) {
                <div
                    class="rounded-xl px-4 py-1 text-center"
                    kendoTooltip
                    title="{{ codelist }}"
                    [pill]="{ status: row[column.field], module: column.codelistName }">
                    {{ codelist }}
                </div>
            } @else if (column.countryFlag) {
                <div class="flex items-center gap-1" kendoTooltip title="{{ row[column.field] }}">
                    <ng-icon size="15px" [name]="getCountryFlag(row[column.field])" />
                    {{ codelist }}
                </div>
            } @else {
                <span
                    class="w-full whitespace-normal break-words"
                    kendoTooltip
                    title="{{ row[column.field] }}"
                    [ngClass]="{ 'font-medium text-black': column.isBold }">
                    {{ codelist }}
                </span>
            }
        } @else {
            @if (column.codelistPill) {
                <div
                    class="rounded-xl px-4 py-1 text-center"
                    [pill]="{ status: row[column.field], module: column.codelistName }">
                    {{ codelist }}
                </div>
            } @else {
                <div
                    class="w-full whitespace-normal break-words"
                    [ngClass]="{ 'font-medium text-black': column.isBold }">
                    {{ codelist }}
                </div>
            }
        }
    </ng-container>
} @else if (column.type === 'select') {
    <app-control type="select" [isEditMode]="false" [options]="column.options" [ngModel]="row[column.field]" />
} @else if (column.type === 'boolean' && column.field === 'active') {
    <span
        *ngIf="row[column.field]"
        class="inline-block h-3 w-3 rounded-full bg-success"
        kendoTooltip
        title="{{ 'Active' | translate }}"></span>
} @else if (column.type === 'boolean' && !column.icon) {
    <app-control type="boolean" [ngModel]="row[column.field]" [isDisabled]="true"></app-control>
} @else if (column.type === 'boolean' && column.icon) {
    <ng-icon *ngIf="row[column.field]" [name]="column.icon.toString()" [ngClass]="column.iconClass"></ng-icon>
} @else if (column.type !== 'boolean' && column.icon) {
    <ng-container>
        {{ row[column.field] }}
        <ng-icon [name]="column.icon.toString()" [ngClass]="column.iconClass" (click)="column.click(row)"></ng-icon>
    </ng-container>
} @else if (column.type === 'yesno') {
    @if (row[column.field] === true) {
        <span [ngClass]="{ 'font-medium text-black': column.isBold }">{{ 'Yes' | translate }}</span>
    } @else if (row[column.field] === false) {
        <span [ngClass]="{ 'font-medium text-black': column.isBold }">{{ 'No' | translate }}</span>
    } @else {
        <span>-</span>
    }
} @else if (column.type === 'date') {
    <span [ngClass]="{ 'font-medium text-black': column.isBold }">{{ row[column.field] | customDate }}</span>
} @else if (column.type === 'datetime') {
    <span [ngClass]="{ 'font-medium text-black': column.isBold }">{{ row[column.field] | datetime }}</span>
} @else if (column.type === 'file') {
    <app-upload-action-buttons [file]="row[column.field]" [disabled]="true" />
} @else if (column.type === 'number') {
    @if (column.format === 'n3') {
        <span [ngClass]="{ 'font-medium text-black': column.isBold }">
            {{ row[column.field] | number: '1.3-3' : 'en-SI' }}
        </span>
    } @else {
        <span [ngClass]="{ 'font-medium text-black': column.isBold }">{{ row[column.field] | number }}</span>
    }
} @else if (column.type === 'decimal') {
    <span [ngClass]="{ 'font-medium text-black': column.isBold }">
        {{ row[column.field] | number: '1.2-2' : 'en-SI' }}
    </span>
} @else {
    @if (column.maxLength && row[column.field].length > column.maxLength) {
        <span kendoTooltip title="{{ row[column.field] }}" [ngClass]="{ 'font-medium text-black': column.isBold }">
            {{ row[column.field].substring(0, column.maxLength) + '...' }}
        </span>
    } @else {
        <div class="w-full whitespace-normal break-words" [ngClass]="{ 'font-medium text-black': column.isBold }">
            {{ row[column.field] }}
        </div>
    }
}
